import { Toastr } from 'modules/toastr';
import { msg } from "constants/message";

let nguoiDungDon = {
  hoVaTen: '',
  soDienThoai: '',
  soCMNDHoChieu: '',
  noiCap: '',
  ngaySinh: '',
  ngayCap: '',
  gioiTinh: 'male',
  diaChi: '',
  tinhThanhId: localStorage.getItem('tpdnId') || '',
  tinhThanhCongDan: {
    ten: ''
  },
  quanHuyenId: '',
  quanHuyenCongDan: {
    ten: ''
  },
  phuongXaId: '',
  phuongXaCongDan: {
    ten: ''
  },
  toThon: '',
  quocTichId: '',
  danTocId: '',
  donCongDanId: '',
  congDanId: ''
}

let initialState = {
  nguoiDungDon: [{...nguoiDungDon}],
  nguoiUyQuyen: {...nguoiDungDon},
  thongTinDonThu: {},
  editData: {},
  soTiepCongDan: {
    listTaiLieuVanThu: []
  },
  PopupViewAllResult: false,
  PopupChiTietCongDan: false,
  popupConfirmSaveLoaiDon: false,
  popupConfirmSaveHuongXuLy: false,
  thongTinXuLyGiaiQuyet: {},
  tuKhoa: '',
  index: '',
  showField: false
}

function formDataTiepCongDan(state = initialState, action) {
  switch (action.type) {
    case 'RESET_FORM':
      return {
        ...state,
        ...initialState
      }
    case 'CHANGE_STATE_LOAIDON':
      return {
        ...state,
        popupConfirmSaveLoaiDon: action.data
      }
    case 'CHANGE_STATE_HUONGXULY':
      return {
        ...state,
        popupConfirmSaveHuongXuLy: action.data
      }
    case 'CAPNHAT_TPID':
      state.nguoiDungDon[0].tinhThanhId = nguoiDungDon.tinhThanhId = localStorage.getItem('tpdnId') || '';
      return {
        ...state
      }
    case 'INIT_NGUOI_DAI_DIEN_CO_QUAN':
      state.nguoiDungDon.splice(1);
      return {
        ...state
      }
    case 'INIT_EDIT_FORM':
      return {
        ...state,
        editData: action.data,
        soTiepCongDan: action.STCD
      }
    case 'REMOVE_LOAIDON_EDIT_FORM':
      return {
        ...state,
        soTiepCongDan: {
          ...state.soTiepCongDan,
          listTaiLieuVanThu: action.data
        }
      }
    case 'THEM_NGUOI_DUNG_DON':
      let newNguoiDungDon = {
        ...nguoiDungDon
      };

      return {
        ...state,
        nguoiDungDon: [
          ...state.nguoiDungDon,
          newNguoiDungDon
        ]
      }
    case 'DISPLAY_FIELD':
    newState = {
      ...state,
      showField: action.value
    };
    return newState;
    case 'CHON_CONG_DAN':
      let newState = {};
      let isExist = false;
      let newData = {};
      state.nguoiDungDon.map((item, i) => {
        if (item.congDanId == action.data.congDanId) {
          isExist = true;
        }
      });
      if (state.nguoiUyQuyen.congDanId == action.data.congDanId) {
        isExist = true;
      }
      if (isExist) {
        Toastr(msg.congDanExist, 'warning');
        return {
          ...state
        }
      } else {
        let removeDonCongDanId = '';
        newData = {
          hoVaTen : action.data.hoVaTen,
          soDienThoai : action.data.soDienThoai,
          soCMNDHoChieu : action.data.soCMNDHoChieu,
          diaChi : action.data.diaChi,
          congDanId : action.data.congDanId,
          noiCap : action.data.noiCapCMNDInfo ? {value: action.data.noiCapCMNDInfo.coQuanQuanLyId, label: action.data.noiCapCMNDInfo.ten} : '',
          ngaySinh : action.data.ngaySinh ? new Date(action.data.ngaySinh) : '',
          ngayCap : action.data.ngayCap ? new Date(action.data.ngayCap) : '',
          gioiTinh : action.data.gioiTinh ? 'male' : 'female',
          tinhThanhId : action.data.tinhThanhCongDan ? action.data.tinhThanhCongDan.donViHanhChinhId : '',
          tinhThanhCongDan : action.data.tinhThanhCongDan,
          quanHuyenId : action.data.quanHuyenCongDan ? action.data.quanHuyenCongDan.donViHanhChinhId : '',
          quanHuyenCongDan : action.data.quanHuyenCongDan ? action.data.quanHuyenCongDan : {ten: ''},
          phuongXaId : action.data.phuongXaCongDan ? action.data.phuongXaCongDan.donViHanhChinhId : '',
          phuongXaCongDan : action.data.phuongXaCongDan ? action.data.phuongXaCongDan : {ten: ''},
          toThon : action.data.toThon,
          quocTichId : action.data.quocTichCongDan ? action.data.quocTichCongDan.quocTichId : '',
          danTocId : action.data.danTocCongDan ? action.data.danTocCongDan.danTocId : ''
        };
        newData.donCongDanId = action.donCongDanId ? action.donCongDanId : '';
        if (state.nguoiDungDon[action.index] && state.nguoiDungDon[action.index].donCongDanId) {
          removeDonCongDanId = state.nguoiDungDon[action.index].donCongDanId;
        }
        if (action.index == -1) {
          newState = {nguoiUyQuyen: newData};
        } else {
          let nguoiDungDons = [
            ...state.nguoiDungDon
          ];
          nguoiDungDons[action.index] = newData;
          newState = {nguoiDungDon: nguoiDungDons};
        }
        return {
          ...state,
          ...newState,
          PopupViewAllResult: false,
          PopupChiTietCongDan: false,
          removeDonCongDanId: removeDonCongDanId
        }
      }
    case 'CHON_DON_THU':
      action.data.listTaiLieuBangChung.map(item => {
        item.tinhTrang = item.tinhTrangTaiLieu;
      });
      action.data.layVuViecCu = true;
      return {
        ...state,
        thongTinDonThu: action.data,
        PopupViewAllResult: false,
        PopupChiTietCongDan: false
      }
    case 'XOA_NGUOI_DUNG_DON':
      return {
        ...state,
        nguoiDungDon: state.nguoiDungDon.filter(item => {
          return item != action.data
        })
      }
    case 'TOGGLE_DIALOG':
      newState = {
        ...state,
        [action.data.name]: action.data.status,
        tuKhoa: action.keyword,
        index: action.index
      };
      if (action.viewDetailCongDanId) {
        newState.viewDetailCongDanId = action.viewDetailCongDanId;
      }
      return newState;
    case 'CAP_NHAT_THONG_TIN_CA_NHAN':
      if (action.index == -1) {
        newState = {nguoiUyQuyen: action.data};
      } else {
        newData = [
          ...state.nguoiDungDon
        ];
        newData[action.index] = action.data;
        newState = {nguoiDungDon: newData}
      }
      return {
        ...state,
        ...newState
      }
    case 'THONG_TIN_XU_LY_GIAI_QUYET':
      return {
        ...state,
        thongTinXuLyGiaiQuyet: action.data
      }
    default:
      return state;
  }
}

export { formDataTiepCongDan }



// WEBPACK FOOTER //
// ./src/reducers/formDataTiepCongDan.js